module.exports = __webpack_public_path__ + "assets/img/servicio-adicional-de-fotografia-rakumart-2-300x300.4255c656.png";